import uniqid from 'uniqid';

import type { mutateNotificationsType } from '@/utils/hooks/swr/useNotifications';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { filtersStateType, setStateFilterType } from '@/components/pages/notifications/types';

import ButtonDeleteNotificationsRead from '@/components/pages/notifications/actions/ButtonDeleteNotificationsRead';
import ButtonMarkAsRead from '@/components/pages/notifications/actions/ButtonMarkAsRead';
// Components
import ButtonCheckbox from '@/components/pages/notifications/filters/ButtonCheckbox';
import SelectCategory from '@/components/pages/notifications/filters/SelectCategory';

type ActionBarProps = {
    filters: filtersStateType;
    setFilters: setStateFilterType;
    total: number;
    total_unread: number;
    mutateNotifications: mutateNotificationsType;
};

const ActionBar = ({
    filters,
    setFilters,
    total,
    total_unread,
    mutateNotifications
}: ActionBarProps) => {
    const { t } = useTranslation();
    return (
        <div className="mb-8 lg:mb-12">
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="flex space-x-3">
                    <ButtonCheckbox
                        count={total}
                        checked={!filters.unread}
                        onChange={() => {
                            setFilters((prevState) => ({
                                ...prevState,
                                unread: false,
                                cacheId: uniqid()
                            }));
                        }}>
                        {t('commons:all')}
                    </ButtonCheckbox>
                    <ButtonCheckbox
                        count={total_unread}
                        checked={filters.unread}
                        onChange={() => {
                            setFilters((prevState) => ({
                                ...prevState,
                                unread: true,
                                cacheId: uniqid()
                            }));
                        }}>
                        {t('commons:unread')}
                    </ButtonCheckbox>
                    <div className="hidden lg:block">
                        <SelectCategory filters={filters} setFilters={setFilters} />
                    </div>
                </div>
                <div className="flex items-center space-x-3 lg:space-x-5">
                    {total_unread > 0 ? (
                        <ButtonMarkAsRead mutateNotifications={mutateNotifications} />
                    ) : null}
                    {total_unread !== total ? (
                        <ButtonDeleteNotificationsRead mutateNotifications={mutateNotifications} />
                    ) : null}
                </div>
            </div>
            <div className="mt-3 lg:hidden">
                <SelectCategory filters={filters} setFilters={setFilters} />
            </div>
        </div>
    );
};

export default ActionBar;
